var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessPrimary2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.849 43.3688L12.84 33.6272C11.7248 32.5417 9.95174 32.5417 8.83646 33.6272C7.72118 34.7127 7.72118 36.4383 8.83646 37.5238L20.8186 49.1859C21.9339 50.2713 23.7355 50.2713 24.8508 49.1859L55.1635 19.7107C56.2788 18.6252 56.2788 16.8996 55.1635 15.8141C54.0483 14.7286 52.2752 14.7286 51.16 15.8141L22.849 43.3688Z",
    fill: "#080206"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessPrimary2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success-primary2.a2e055549870da7646fedc1958586e72.svg";